# frozen_string_literal: true

# Frozen copy of Vogel's Scheme of 1870 at playtest commit 372915020 (2026-10-06).
# Never edit it: rule changes go into the current version. See CHANGELOG.playtest.md.

module Engine
  module Game
    module GVogel1870V1
    end
  end
end
